import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_content_block = _resolveComponent("product-content-block")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.productGrapes.length)
    ? (_openBlock(), _createBlock(_component_carousel, {
        key: 0,
        class: _normalizeClass(["product-grape carousel--progress-bar", {
      'product-grape--has-carousel': _ctx.productGrapes.length && _ctx.productGrapes.length > 1
    }]),
        "slides-count": _ctx.productGrapes.length,
        "slides-per-view": 1,
        "show-pagination": true
      }, _createSlots({ _: 2 /* DYNAMIC */ }, [
        _renderList(_ctx.productGrapes, (productGrape, index) => {
          return {
            name: `slide-${index}`,
            fn: _withCtx(() => [
              _createVNode(_component_product_content_block, {
                "show-carousel": _ctx.showCarousel,
                headline: productGrape.displayName,
                subline: productGrape.subtitle,
                text: productGrape.shortDescription,
                "link1-text": productGrape.linkText,
                "link1-url": productGrape.linkUrl,
                "link2-text": productGrape.linkText2,
                "link2-url": productGrape.linkUrl2,
                images: productGrape.images,
                type: "grape"
              }, null, 8 /* PROPS */, ["show-carousel", "headline", "subline", "text", "link1-text", "link1-url", "link2-text", "link2-url", "images"])
            ])
          }
        })
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "slides-count"]))
    : _createCommentVNode("v-if", true)
}